export default __webpack_public_path__ + "static/media/nopcommerce.97417910.png";